import { render, staticRenderFns } from "./couponDetail.vue?vue&type=template&id=4cf3d829&scoped=true&"
import script from "./couponDetail.vue?vue&type=script&lang=ts&"
export * from "./couponDetail.vue?vue&type=script&lang=ts&"
import style0 from "./couponDetail.vue?vue&type=style&index=0&id=4cf3d829&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf3d829",
  null
  
)

export default component.exports